import React, { PureComponent } from 'react';
import { Button } from '@ui-propulsion/react-components';
import PNI from './pni';
import NonPNI from './non-pni';
import classNames from 'classnames';
import BackButton from '../back-button';
import Spinner from '../spinner';

class PaymentPlans extends PureComponent {

  constructor(props) {
    super(props);

    this.showPNIAndPRP = (props.practice.type === 'Dental' || props.practice.type === 'Hair Restoration');

    this.state = {
      hasNoMaxPNITerm: (this.showPNIAndPRP && (props.practice.maxPNITerm === undefined || props.practice.maxPNITerm === '-1')),
      maxPNITerm: props.practice.maxPNITerm || -1,
      shouldShowUpdatedAdsTerms: props.shouldShowUpdatedAdsTerms
    };
  }

  renderPNI = () => {
    return (
      this.showPNIAndPRP
      ? <PNI
          onPlanSelected={this.handleOnPlanSelected}
          selectedPlan={this.props.practice.maxPNITerm}
          shouldShowUpdatedAdsTerms={this.props.shouldShowUpdatedAdsTerms}
        />
      : null
    );
  }

  handleOnPlanSelected = (maxTerm) => {
    this.setState({
      hasNoMaxPNITerm: (this.showPNIAndPRP && (maxTerm === void(0))),
      maxPNITerm: maxTerm
    });
  }

  handleSubmit = () => {
    const { isInReview, actions, actions: { submitPaymentPlans } } = this.props;
    const { maxPNITerm } = this.state;
    const isMaxPNIValidationRequired = this.showPNIAndPRP;
    submitPaymentPlans({ maxPNITerm, isMaxPNIValidationRequired })
      .then((result) => {
        if (result && result.capAlreadyReview) { return; }

        actions.setPreviousRoute('/patientsolutions/enroll/payment-plans');
        const route = isInReview
          ? '/patientsolutions/enroll/review'
          : '/patientsolutions/enroll/ownership';
        this.props.history.push(route);
      })
      .catch(({ response }) => {
        const { status, data } = response;
        
        if (status && status !== 400) {
          window.location.href = '/patientsolutions/enroll/error';
        }

        if (data && data.redirectTo) {
          window.location.href = data.redirectTo;
        }
      });
  }

  render() {
    const { isInReview, onboarding, shouldShowUpdatedAdsTerms } = this.props;
    const { processingSubmit, hasCompletedReview } = onboarding;

    const previousRoute = isInReview
      ? onboarding.previousRoute
      : '/patientsolutions/enroll/practice-information';

    const { hasNoMaxPNITerm } = this.state;
    const disabled = hasNoMaxPNITerm || hasCompletedReview;

    return <section className='header-section payment-plans'>
      <BackButton {...this.props} previousRoute={previousRoute} />
      <h1 className={classNames('section-title', 'payment-plans-mobile')}>{this.showPNIAndPRP ? 'Select the payment options you will offer your patients' : 'Confirm the payment options you will offer your patients'}</h1>
      { this.showPNIAndPRP && <p className='payment-plans-mobile'>There are no upfront costs to select multiple plans. <b>You’ll be able to change your options in the future.</b></p>}
      <form className='payment-plans-form'>
        { this.renderPNI() }
        <NonPNI id="non-pni-frp" fixedRatePlan={true} showPNIAndPRP={this.showPNIAndPRP} practiceType={this.props.practice.type} shouldShowUpdatedAdsTerms={shouldShowUpdatedAdsTerms} />
        { this.showPNIAndPRP && <NonPNI id="non-pni" fixedRatePlan={false} showPNIAndPRP={this.showPNIAndPRP} practiceType={this.props.practice.type} shouldShowUpdatedAdsTerms={shouldShowUpdatedAdsTerms}/>}

        <div className={classNames('action-area', 'payment-plans-mobile')}>
          <Button
            data-test-id="next-step-button"
            className={classNames('button-submit button-submit-next', { disabled })}
            disabled={disabled}
            onClick={this.handleSubmit}
            aria-label='practice submit button'>
            <span className='button-submit-text'>Next</span>
          </Button>

          <div className={classNames('section-helper-txt', disabled ? 'helper-display-block' : 'helper-display-none')}>
            Please select a Promotional No Interest option to proceed.
          </div>
        </div>

        { processingSubmit && <Spinner processingSubmit={processingSubmit}/> }

      </form>
    </section>;
  }
}

export default PaymentPlans;

